'use client'

import { dataTestIds } from 'pdp/src/constants/dataTestIds/dataTestIds'
import type { Media } from 'pdp/src/types/FullProduct'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { cx } from 'utils/cx'

import { Video } from '../../Video/Video'
import { ZoomableImage } from '../../ZoomableImage/ZoomableImage'
import { IMAGE_ASPECT_RATIO } from '../ImageGrid'
import styles from './ImageGridItem.module.scss'

const MIN_IMAGES_TO_SHOW = 4

export const ImageGridItem = ({
	mediaItem,
	index,
	viewWidth,
	className,
}: {
	readonly mediaItem: Media
	readonly index: number
	readonly viewWidth: string
	readonly className: string
}) => {
	const { isLessThanLarge, availableScreenSize } = useResponsive()

	return (
		<li className={cx(className, styles.imageItem)} key={mediaItem.type}>
			{mediaItem.format === 'IMAGE' ? (
				<ZoomableImage
					label={`Zoom Image ${index + 1}`}
					media={mediaItem}
					priority={
						availableScreenSize &&
						!isLessThanLarge &&
						index < MIN_IMAGES_TO_SHOW
					}
					className={styles.image}
					sizes={`(min-width: 1024px) ${viewWidth}`}
					height={1}
					width={IMAGE_ASPECT_RATIO}
					dataTestid={dataTestIds['pdp.gallery.image']}
				/>
			) : (
				<Video className={styles.image} url={mediaItem.src} />
			)}
		</li>
	)
}
